<template>
    <div class="row">
        <div class="col-12 col-sm-6 col-md-4 offset-md-2">
            <span class="title">Rechtsgebiete</span>
            <p class="mt-5">Sie können sich mit allen Fragen und Problemen an mich wenden, die die Bereiche Mietrecht, Familienrecht und Strafrecht betreffen.</p>
            <p>Auf entsprechende Anfrage bin ich im Einzelfall bereit, Mandate aus anderen Rechtsgebieten anzunehmen.</p>
        </div>
        <div class="col-12 col-sm-5 col-md-4 offset-sm-1 offset-md-1 mt-sm-30">
            <p class="title center-sm">Schwerpunkte</p>
            <ul class="fields-of-law mt-5 margin-sm">
                <li><a @click.prevent="$emit('routeTo', 'lot')" href="#">Mietrecht</a></li>
                <li><a @click.prevent="$emit('routeTo', 'fl')" href="#">Familienrecht</a></li>
                <li><a @click.prevent="$emit('routeTo', 'cl')" href="#">Strafrecht</a></li>
            </ul>
        </div>

    </div>
</template>

<script>
    export default {
        name: "FieldOfRights.vue"
    }
</script>

<style scoped>

</style>